import React from "react";
import { Link } from "react-router-dom";

export default function Dashboard() {
  const buttonStyle = {
    padding: "12px 20px",
    marginBottom: 10,
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: 5,
    width: "90%",
    fontSize: 16,
    textAlign: "center",
  };

  const logoutStyle = {
    padding: "12px 20px",
    marginTop: 20,
    backgroundColor: "red",
    color: "white",
    border: "none",
    borderRadius: 5,
    width: "90%",
    fontSize: 16,
    textAlign: "center",
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Admin Dashboard</h2>
      <h2>Welcome Sir.</h2>

      <Link to="/technician-list">
        <button style={buttonStyle}>👨‍🔧 Technician List</button>
      </Link>
      <Link to="/handle-customer-complaints">
        <button style={buttonStyle}>📢 View Customer Complaints</button>
      </Link>
      <Link to="/technician-rating-average">
        <button style={buttonStyle}>📦 Technician Rating Average</button>
      </Link>
      <Link to="/resolve-technician-issue">
        <button style={buttonStyle}>🚨 Update Technician Issues</button>
      </Link>
      <Link to="/full-orders">
        <button style={buttonStyle}>📦 Assign Orders Payment Update</button>
      </Link>
      <Link to="/Technician-Payment">
        <button style={buttonStyle}>💰 Update Technician Payment</button>
      </Link>

      {/* ✅ NEW BUTTON FOR REFERRAL EARNING CHECK */}
      <Link to="/paid-referral-by">
        <button style={buttonStyle}>🎁 Update Referralby Payment</button>
      </Link>

      {/* 🔴 Logout Button */}
      <button
        onClick={() => {
          localStorage.removeItem("adminLoggedIn");
          window.location.href = "/admin-login";
        }}
        style={logoutStyle}
      >
        🔒 Logout
      </button>
    </div>
  );
}
